export default "__VITE_ASSET__0x$50h6w__"